import React, { useEffect, useState } from "react";

// js
import { changeHeaderBackGround } from "../js/main";

// action
import { loginRegister } from "../store/user/action";
// redux
import { connect } from "react-redux";

// validation
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const Register = (props) => {
    useEffect(() => {
        changeHeaderBackGround();
    }, []);

    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");


    const preferenceArray = [
        "Chinese",
        "Italian",
        "Baked Goods"
    ];

    // form validation rules
    const validationSchema = Yup.object().shape({
        name: Yup.string().trim().required("Name is Required!"),
        username: Yup.string().trim().required("Username is Required!"),
        password: Yup.string().trim().required("Password is Required!"),
        preference: Yup.string().trim().required("Please select Preference!"),
        email: Yup.string().trim().required("Email is Required!").matches(/^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/, "Invalid Email!"),
    });

    const {
        register,
        trigger,
        handleSubmit,
        formState: { errors },
    } = useForm({ mode: "onChange", resolver: yupResolver(validationSchema) });

    const onSubmit = (values) => {
        props.loginRegister({ type: "register", data: values });
    };

    const setPreferenceValue = async (value) => {
        await trigger(['preference']);
    };

    useEffect(() => {
        if (name) setEmail(`${name + username}@gmail.com`)
    }, [name, username, email])

    return (
        <main id="main">
            <section>
                <h1 className="text-center my-5">Registration</h1>
                <div className="container">
                    <form className="form" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="row">
                            <div className="col-md-6 form-group">
                                <label
                                    for="name"
                                    className="small font-weight-bold text-warning"
                                >
                                    Name
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                    id="name"
                                    placeholder="Your Name"
                                    required
                                    // disabled={true}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                // {...register("name")}

                                />
                                <div className="invalid-feedback">{errors.name?.message}</div>
                            </div>
                            <div className="col-md-6 form-group mt-3 mt-md-0">
                                <label
                                    for="username"
                                    className="small font-weight-bold text-warning"
                                >
                                    Username
                                </label>
                                <input
                                    type="text"
                                    name="username"
                                    className={`form-control ${errors.username ? "is-invalid" : ""}`}
                                    id="username"
                                    placeholder="Your Username"
                                    required
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                // {...register("username")}

                                />
                                <div className="invalid-feedback">
                                    {errors.username?.message}
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label
                                for="email"
                                className="small font-weight-bold text-warning"
                            >
                                Email
                            </label>
                            <input
                                type="email"
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                name="email"
                                id="email"
                                placeholder="Your Email"
                                required
                                value={email}
                            // onChange={(e) => setEmail(`${name + username}@gmail.com`)}
                            // {...register("email")}

                            />
                            <div className="invalid-feedback">{errors.email?.message}</div>
                        </div>
                        <div className="form-group">
                            <label
                                for="password"
                                className="small font-weight-bold text-warning"
                            >
                                Password
                            </label>
                            <input
                                type="password"
                                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                name="password"
                                id="password"
                                placeholder="Your Password"
                                required
                                {...register("password")}

                            />
                            <div className="invalid-feedback">{errors.password?.message}</div>
                        </div>
                        <div className="form-group">
                            <label
                                for="password"
                                className="small font-weight-bold text-warning"
                            >
                                Select Preference
                            </label>
                            <select
                                className={`form-control form-select ${errors.preference ? "is-invalid" : ""
                                    }`}
                                onChange={(e) => setPreferenceValue(e.target.value.toString())}
                                {...register("preference")}
                            >
                                <option value="" disabled selected>
                                    Select Preference
                                </option>
                                {preferenceArray?.map((data) => <option value={data}>{data}</option>)}
                            </select>
                            <div className="invalid-feedback">
                                {errors.preference?.message}
                            </div>
                        </div>

                        <div className="text-center">
                            <button type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </main>
    );
};

export default connect(null, { loginRegister })(Register);
